module.exports = __webpack_public_path__ + "img/burger.52909849.svg";